import React, { FC } from 'react';
import { Core } from '@everfi/reactifi';

interface MainLayoutProps {
  header?: React.ReactNode;
  children: React.ReactNode;
}

export const UnAuthenticatedWrapper: FC<MainLayoutProps> = ({ header, children }) => {
  return (
    <Core.Layout bg={'surface-inset'} minH={'100vh'}>
      <Core.Layout bg={'surface-page'}>
        {header && (
          <Core.Layout maxW={'container.lg'} mx={'auto'}>
            {header}
          </Core.Layout>
        )}
      </Core.Layout>

      <Core.Layout>
        <Core.Layout variant={'flex'} maxW={'container.lg'} mx={'auto'} flexDirection={'column'} gap={'sm'}>
          {children}
        </Core.Layout>
      </Core.Layout>
    </Core.Layout>
  );
};
